
import { Navigate } from "react-router";
import { OrganizationIcon } from "../../../../shared/components/svgIcons";
import PaymentsList from "../components/paymentsList";
import PaymentsView from "../components/paymentsView";

const paymentsRoute = {
  link: "/fees",
  path: "/fees",
  name: "Fees ",
  element: "",
  icon: OrganizationIcon,
  index: 4,
  children: [
    {
      path: "payments-listing",
      element: <PaymentsList />,
      permission: "Payments",
      link: "fees/payments-listing",
      name: "Fees Report",
      icon: OrganizationIcon,
      index: 3,
    },
    {
      path: "payments/:id",
      element: <PaymentsView />,
    },
    {
      path: "",
      element: <Navigate to="/fees/payments-listing" replace />,
    }
  ]
}
export default paymentsRoute;